// Define Preview and Next Button for embla slider
const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
  const togglePrevNextBtnsState = () => {
    // Enable or disable the previous button
    if (emblaApi.canScrollPrev()) {
      prevBtn.removeAttribute('disabled');
    } else {
      prevBtn.setAttribute('disabled', 'disabled');
    }

    // Enable or disable the next button
    if (emblaApi.canScrollNext()) {
      nextBtn.removeAttribute('disabled');
    } else {
      nextBtn.setAttribute('disabled', 'disabled');
    }
  };

  // Attach event listeners for state changes
  emblaApi
    .on('select', togglePrevNextBtnsState)
    .on('init', togglePrevNextBtnsState)
    .on('reInit', togglePrevNextBtnsState);

  return () => {
    // Reset button states
    prevBtn.removeAttribute('disabled');
    nextBtn.removeAttribute('disabled');
  };
};
// Define click handlers for embla slider
const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
  const scrollPrev = () => {
    emblaApi.scrollPrev();
  };

  const scrollNext = () => {
    emblaApi.scrollNext();
  };

  // Add click event listeners
  prevBtn.addEventListener('click', scrollPrev, false);
  nextBtn.addEventListener('click', scrollNext, false);

  // Initialize toggle button state management
  const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
    emblaApi,
    prevBtn,
    nextBtn
  );

  return () => {
    // Clean up event listeners and states
    removeTogglePrevNextBtnsActive();
    prevBtn.removeEventListener('click', scrollPrev, false);
    nextBtn.removeEventListener('click', scrollNext, false);
  };
};
// Helper function to create dots for embler Slider
const createDots = (dots, slider) => {
  const dotsArray = [...dots.children];
  
  // Add accessibility attributes to each dot
  dotsArray.forEach((dot, index) => {
    dot.setAttribute('role', 'button');        
    dot.setAttribute('aria-label', `Showing Slide ${index + 1} of ${dotsArray.length}`);
  });

  const updateDots = () => {
    const selectedIndex = slider.selectedScrollSnap();
    dotsArray.forEach((dot, index) => {
      dot.classList.toggle('is-selected', index === selectedIndex);      
      dot.setAttribute('aria-label', `Showing Slide ${index + 1} of ${dotsArray.length}`);
    });
  };
  
  slider
    .on('select', updateDots)
    .on('init', updateDots)
    .on('reInit', updateDots);
};

// Tab Function
class carouselTabs {
  constructor() {
    this.tabButtons = document.querySelectorAll('.carousel-toggle');
    this.tabContents = document.querySelectorAll('.carousel__component');
    this.init();
  }

  init() {
    if (this.tabButtons && this.tabContents) {
      this.addClickListeners();
    }
  }

  addClickListeners() {
    this.tabButtons.forEach(tabBtn => {
      tabBtn.addEventListener('click', () => this.handleTabClick(tabBtn));
    });
  }

  handleTabClick(clickedTab) {
    const tabId = clickedTab.getAttribute('data-id');
    this.updateActiveStates(clickedTab, tabId);
  }

  updateActiveStates(clickedTab, tabId) {
    // Update tab buttons
    this.tabButtons.forEach(btn => btn.classList.remove('active'));
    clickedTab.classList.add('active');

    // Update tab contents
    this.tabContents.forEach(content => {
      content.classList.remove('active');
      if (content.id === tabId) {
        content.classList.add('active');
      }
    });
  }
}

class Accordion {
  constructor() {
    this.accordionItems = document.querySelectorAll('.accordion');
    this.init();
  }
  init() {
    this.accordionItems.forEach((item, index) => {
      const trigger = item.querySelector('.accordion__toggle');
      const content = item.querySelector('.accordion__content');
              
      const isFirstItem = index === 0;
      trigger.setAttribute('aria-expanded', isFirstItem ? 'true' : 'false');
      content.setAttribute('aria-hidden', isFirstItem ? 'false' : 'true');
      
      if (isFirstItem) {
        content.style.height = `${content.scrollHeight}px`;
        item.classList.add('is-open');
      } else {
        content.style.height = '0';
      }        
        trigger.addEventListener('click', () => this.handleClick(item));
        trigger.addEventListener('keydown', (e) => this.handleKeydown(e));
      });
  }

  handleClick(item) {
    const trigger = item.querySelector('.accordion__toggle');
    const content = item.querySelector('.accordion__content');
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        
    this.accordionItems.forEach(otherItem => {
      if (otherItem !== item) {
        const otherTrigger = otherItem.querySelector('.accordion__toggle');
        const otherContent = otherItem.querySelector('.accordion__content');
        
        otherTrigger.setAttribute('aria-expanded', 'false');
        otherContent.setAttribute('aria-hidden', 'true');
        otherContent.style.height = '0';
        otherItem.classList.remove('is-open');
      }
    });
      
    trigger.setAttribute('aria-expanded', !isExpanded);
    content.setAttribute('aria-hidden', isExpanded);
    content.style.height = isExpanded ? '0' : `${content.scrollHeight}px`;
    item.classList.toggle('is-open');
  }

  handleKeydown(e) {
    const targetItem = e.target.closest('.accordion');
      
    switch (e.key) {
    case 'ArrowUp':
      e.preventDefault();
      const prev = targetItem.previousElementSibling;
      if (prev) prev.querySelector('.accordion__toggle').focus();
      break;
    case 'ArrowDown':
      e.preventDefault();
      const next = targetItem.nextElementSibling;
      if (next) next.querySelector('.accordion__toggle').focus();
      break;
    case 'Home':
      e.preventDefault();
      this.accordionItems[0].querySelector('.accordion__toggle').focus();
      break;
    case 'End':
      e.preventDefault();
      this.accordionItems[this.accordionItems.length - 1].querySelector('.accordion__toggle').focus();
      break;
    }
  }
}

class AccordionGlobal {
  constructor(container) {
    this.container = container;
    this.controls = this.container.querySelectorAll('.accordion-control');
    this.init();
  }
  
  init() {
    this.controls.forEach(control => {
      const content = control.nextElementSibling;
      content.style.height = '0';
      content.style.overflow = 'hidden';
      content.style.transition = 'height 0.3s ease-in-out';
      content.style.display = 'block'; // Always display but with 0 height when closed
      
      control.addEventListener('click', this.toggleAccordion.bind(this, control));
    });
  }
  
  toggleAccordion(control) {
    const content = control.nextElementSibling;
    const isOpen = control.classList.contains('active');
        
    this.closeAll();

    if (!isOpen) {
    
      control.classList.add('active');
          
      const contentHeight = content.scrollHeight;
      content.style.height = contentHeight + 'px';
            
      const iconWrapper = control.querySelector('.icon-wrapper');
      if (iconWrapper) {
        iconWrapper.classList.add('open');
      }
    }
  }
  
  closeAll() {
    this.controls.forEach(control => {
      control.classList.remove('active');
      const content = control.nextElementSibling;
      content.style.height = '0';
      
      const iconWrapper = control.querySelector('.icon-wrapper');
      if (iconWrapper) {
        iconWrapper.classList.remove('open');
      }
    });
  }
  
  openAll() {
    this.controls.forEach(control => {
      control.classList.add('active');
      const content = control.nextElementSibling;
      content.style.height = content.scrollHeight + 'px';
      
      const iconWrapper = control.querySelector('.icon-wrapper');
      if (iconWrapper) {
        iconWrapper.classList.add('open');
      }
    });
  }
  
  open(index) {
    if (index >= 0 && index < this.controls.length) {
      this.toggleAccordion(this.controls[index]);
    }
  }
}

// Handle Embla Slider
class CarouselInitializer {
  static mobileBreakpoint = 749;
  static alternativeSliderInstances = new Map();
  
  static initCarousels() {
    // Marketing Bar Carousel
    const mbNode = document.querySelector('.marketing-bar');
    if (mbNode) {
      const mbViewportNode = mbNode.querySelector('.marketing-bar--inner');
      const mbOptions = {
        active: false,
        loop: true,
        breakpoints: {
          '(max-width: 768px)': { active: true, loop: true },
        }
      };
      const marketBar = EmblaCarousel(mbViewportNode, mbOptions, [EmblaCarouselAutoplay()]);
    }

    // Main Image Sliders
    const carousels = document.querySelectorAll('.embla');
    carousels.forEach(carousel => {
      const viewportNode = carousel.querySelector('.embla__viewport');
      const prevButton = carousel.querySelector('.embla__button--prev');
      const nextButton = carousel.querySelector('.embla__button--next');
      const dots = carousel.querySelector('.embla__dots');

      // Get options from HTML attributes
      const loop = carousel.getAttribute('data-loop') === 'true';
      const autoplayDelay = parseInt(carousel.getAttribute('data-autoplay-delay'), 10) || 3000; // Default to 3000ms
      const showDots = carousel.getAttribute('data-show-dots') === 'true';
      const showArrows = carousel.getAttribute('data-show-arrows') === 'true';
      const autoplayEnabled = carousel.getAttribute('data-autoplay') === 'true'; // Check if autoplay is enabled

      const options = {
        active: true,
        loop: loop,
        slidesToScroll: 1,
      };

      const autoplayOptions = autoplayEnabled ? {
        delay: autoplayDelay, // Set delay time in milliseconds
      } : null;
      
      const slider = EmblaCarousel(viewportNode, options, autoplayEnabled ? [EmblaCarouselAutoplay(autoplayOptions)] : []);

      if (showArrows && prevButton && nextButton) {
        const removePrevNextHandlers = addPrevNextBtnsClickHandlers(
          slider,
          prevButton,
          nextButton
        );
        slider.on('destroy', removePrevNextHandlers);
      }

      if (showDots && dots) {
        // Create dot buttons
        const slides = viewportNode.querySelectorAll('.embla__slide');
        slides.forEach(() => {
          const dot = document.createElement('button');
          dot.classList.add('embla__dot');
          dots.appendChild(dot);
        });

        // Add click handlers to dots
        const dotsArray = [...dots.children];
        dotsArray.forEach((dot, index) => {
          dot.addEventListener('click', () => slider.scrollTo(index));
        });

        createDots(dots, slider);
      }
    });
  
    // Sub Collection Navigation Carousel
    const subCollectionCarousels = document.querySelectorAll('.sub-collection-wrapper');
    subCollectionCarousels.forEach(carousel => {
      const viewportNode = carousel.querySelector('.sub-collection-wrapper__inner');
      const prevButton = carousel.querySelector('.embla__button--prev');
      const nextButton = carousel.querySelector('.embla__button--next');
      if (!viewportNode) return;

      const options = {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: true, // Set to false for snapped sliding
        draggable: true,
        loop: false,
        breakpoints: {
          '(max-width: 749px)': { slidesToShow: 2 },
          '(min-width: 750px)': { slidesToShow: 'auto' }
        }
      };
      
      const slider = EmblaCarousel(viewportNode, options);

      // Add prev/next button handlers
      if (prevButton && nextButton) {
        const removePrevNextHandlers = addPrevNextBtnsClickHandlers(
          slider,
          prevButton,
          nextButton
        );
        slider.on('destroy', removePrevNextHandlers);
      }

      // Scroll to active item if exists
      const scrollToActive = () => {
        const slides = viewportNode.querySelectorAll('li');
        slides.forEach((slide, index) => {
          if (slide.querySelector('.active')) {
            slider.scrollTo(index);
          }
        });
      };

      // Initialize scroll to active
      slider.on('init', scrollToActive);
      slider.on('reInit', scrollToActive);
    });
    
    // Product Alternative Sliders
    this.initProductAlternativeSliders();
  }
  
  // Methods for Product Alternative Sliders
  static initProductAlternativeSliders() {
    const alternativeSliders = document.querySelectorAll('.alternative-products--items');
    
    alternativeSliders.forEach(slider => {
      // Check if slider should be enabled
      const enableSliderMobile = slider.getAttribute('data-slider-mobile') === 'true';
      const enableSliderDesktop = slider.getAttribute('data-slider-desktop') === 'true';
      
      // Initialize if either mobile or desktop is enabled
      if (enableSliderMobile || enableSliderDesktop) {
        this.initializeAlternativeSlider(slider, enableSliderMobile, enableSliderDesktop);
      }
    });
  }
  
  static initializeAlternativeSlider(slider, enableSliderMobile, enableSliderDesktop) {
    // Don't initialize again if already exists
    if (this.alternativeSliderInstances.has(slider)) return;
    
    const viewportNode = slider.querySelector('.embla__viewport');
    if (!viewportNode) return;
    
    // Get configuration from data attributes
    const loop = slider.getAttribute('data-loop') === 'true';
    const showArrows = slider.getAttribute('data-show-arrows') === 'true';
    const showDots = slider.getAttribute('data-show-dots') === 'true';
    const autoplay = slider.getAttribute('data-autoplay') === 'true';
    const slidesPerView = parseInt(slider.getAttribute('data-slides-per-view'), 10) || 1;
    const desktopSlidesPerView = parseInt(slider.getAttribute('data-desktop-slides-per-view'), 10) || slidesPerView || 3;
    
    // Create options object with breakpoints based on which view modes are enabled
    let options = {};
    
    if (enableSliderMobile && enableSliderDesktop) {
      // Both mobile and desktop enabled - different configurations
      options = {
        active: true, // Active by default (desktop)
        loop: loop,
        dragFree: false,
        containScroll: 'trimSnaps',
        slidesToScroll: 2,
        slidesToShow: desktopSlidesPerView
      };
    } else if (enableSliderMobile && !enableSliderDesktop) {
      // Only mobile slider enabled
      options = {
        active: false, // Inactive by default (desktop)
        loop: loop,
        dragFree: false,
        containScroll: 'trimSnaps',
        slidesToScroll: 2,
        breakpoints: {
          [`(max-width: ${this.mobileBreakpoint}px)`]: { 
            active: true,
            loop: loop,
            slidesToShow: slidesPerView
          }
        }
      };
    } else if (!enableSliderMobile && enableSliderDesktop) {
      // Only desktop slider enabled
      options = {
        active: true, // Active by default (desktop)
        loop: loop,
        dragFree: false,
        containScroll: 'trimSnaps',
        slidesToScroll: 2,
        slidesToShow: desktopSlidesPerView,
        breakpoints: {
          [`(max-width: ${this.mobileBreakpoint}px)`]: { 
            active: false
          }
        }
      };
    }
    
    // Initialize Embla carousel
    const emblaApi = EmblaCarousel(viewportNode, options, 
      autoplay ? [EmblaCarouselAutoplay({ delay: 3000 })] : []);
    
    // Store the instance
    this.alternativeSliderInstances.set(slider, emblaApi);
    
    // Initialize navigation buttons
    if (showArrows) {
      const prevButton = slider.querySelector('.embla__button--prev');
      const nextButton = slider.querySelector('.embla__button--next');
      
      if (prevButton && nextButton) {
        const removePrevNextHandlers = addPrevNextBtnsClickHandlers(
          emblaApi,
          prevButton,
          nextButton
        );
        emblaApi.on('destroy', removePrevNextHandlers);
      }
    }
    
    // Initialize dots
    if (showDots) {
      const dots = slider.querySelector('.embla__dots');
      if (dots) {
        // Create dot buttons
        const slideCount = viewportNode.querySelectorAll('.embla__slide').length;
        for (let i = 0; i < slideCount; i++) {
          const dot = document.createElement('button');
          dot.classList.add('embla__dot');
          dots.appendChild(dot);
        }
        
        // Add click handlers to dots
        const dotsArray = [...dots.children];
        dotsArray.forEach((dot, index) => {
          dot.addEventListener('click', () => emblaApi.scrollTo(index));
        });
        
        createDots(dots, emblaApi);
      }
    }
  }
}

// Navigation Indicator
class NavigationIndicator {
  constructor() {
    this.container = document.querySelector('.nav--menu');
    if (!this.container) return;
    
    this.activeLink = this.container.querySelector('.nav--link.active') || 
    this.container.querySelector('.nav--link'); 
    this.init();
  }
  init() {    
    this.update(this.activeLink);        
    this.container.addEventListener('click', (e) => this.handleClick(e));
  }
  update(el) {
    this.container.style.setProperty('--width',`${el.getBoundingClientRect().width}px`);
    this.container.style.setProperty('--offset', `${el.offsetLeft}px`);
  }
  handleClick(e) {
    if (e.target.classList.contains('nav--link')) {    
        this.container.querySelectorAll('.nav--link').forEach(link => {
        link.classList.remove('active');
      });
      e.target.classList.add('active');
      this.update(e.target);
    }
  }
}

// Tab Navigation
class TabNavigation {
  constructor() {
    this.tabList = document.querySelector('.nav--menu');
    this.tabs = document.querySelectorAll('.tab--link');
    this.panels = document.querySelectorAll('.tab--panel');
    
    if (this.tabList && this.tabs.length && this.panels.length) {
      this.init();
    }
  }

  init() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchTab(tab);
      });
    });
  }

  switchTab(selectedTab) {
    const targetId = selectedTab.getAttribute('data-tab');

    // Update tabs
    this.tabs.forEach(tab => {
      tab.classList.remove('active');
      if (tab === selectedTab) {
        tab.classList.add('active');
      }
    });

    // Update panels
    this.panels.forEach(panel => {
      panel.classList.remove('active');
      panel.style.display = 'none';
      if (panel.id === `panel-${targetId}`) {
        panel.classList.add('active');
        panel.style.display = '';
      }
    });
  }
}

class FooterAccordion {
  constructor() {    
    document.addEventListener('DOMContentLoaded', () => {      
      this.accordions = document.querySelectorAll('.footer-accordion_item');
      
      if (this.accordions.length) {
        this.init();
      }
    });
  }

  init() {
    this.accordions.forEach(accordion => {
      const header = accordion.querySelector('.accordion-footer_header');
      const content = accordion.querySelector('.accordion-footer_content');
      
      if (header && content) {
        header.addEventListener('click', () => {          
          if (window.innerWidth < 768) {
            header.classList.toggle('active');
            content.classList.toggle('active');
          }
        });
      }
    });
  }
}

class ShowMoreButton {
  constructor() {
    this.nav = document.querySelector('.show-more__content');
    this.navLink = document.querySelector('.btn--show-more');
    this.animateTime = 300;
    this.collapsedHeight = 135;
    this.isExpanded = false;
    
    if (this.nav && this.navLink) {
      this.init();
    }
  }

  init() {
    this.navLink.addEventListener('click', () => this.toggleHeight());
  }

  toggleHeight() {
    this.isExpanded = !this.isExpanded;
    
    if (this.isExpanded) {
      this.autoHeightAnimate(this.nav, this.animateTime);
      document.querySelector('.peek-shadow-block').classList.remove('peek-show');
      this.navLink.textContent = 'Show Less';
    } else {
      this.nav.style.height = `${this.collapsedHeight}px`;
      document.querySelector('.peek-shadow-block').classList.add('peek-show');
      this.navLink.textContent = 'Show More';
    }
  }

  autoHeightAnimate(element, time) {
    const curHeight = element.offsetHeight;
    element.style.height = 'auto';
    const autoHeight = element.offsetHeight;
    element.style.height = curHeight + 'px';
    
    element.style.transition = `height ${time}ms`;
    requestAnimationFrame(() => {
      element.style.height = autoHeight + 'px';
    });
  }
}

class QuantitySelector {
  constructor() {
    this.quantityLabels = document.querySelectorAll('.multi-buy--option');
    this.quantityInput = document.querySelector('[name="quantity"]');
    
    if (this.quantityLabels.length && this.quantityInput) {
      this.init();
    }
  }

  init() {
    // Set initial active state and quantity
    const firstLabel = this.quantityLabels[0];
    if (firstLabel) {
      firstLabel.classList.add('active');
      const initialQuantity = firstLabel.getAttribute('data-quantity');
      if (initialQuantity) {
        this.quantityInput.value = initialQuantity;
      }
    }
    
    // Add click handlers
    this.quantityLabels.forEach(label => {
      label.addEventListener('click', (e) => {
        e.preventDefault(); // Prevent default behavior
        this.handleClick(label);
      });
    });
  }

  handleClick(clickedLabel) {
    if (!clickedLabel) return;
    
    this.quantityLabels.forEach(label => {
      label.classList.remove('active');
    });
    clickedLabel.classList.add('active');
    
    const selectedQuantity = clickedLabel.getAttribute('data-quantity');
    if (selectedQuantity && this.quantityInput) {
      this.quantityInput.value = selectedQuantity;
      const event = new Event('change', { bubbles: true });
      this.quantityInput.dispatchEvent(event);
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const accordionContainers = document.querySelectorAll('.section-accordion');
  
  accordionContainers.forEach(container => {
    new AccordionGlobal(container);
  });
});


class Themejs {
  static init() {
    CarouselInitializer.initCarousels();
    new carouselTabs();
    new Accordion();
    new NavigationIndicator();
    new TabNavigation();
    new FooterAccordion();
    new ShowMoreButton();
    new QuantitySelector();
  }
}

Themejs.init();
